import * as ImageManipulator from 'expo-image-manipulator';
import type { ImagePickerAsset } from 'expo-image-picker';

import {
  MAX_SIZE,
  ACCEPTED_MIME_TYPES
} from '@/features/media/constants/image';
import { getFileSize } from '@/features/media/utils/file-size/fileSize';

// Todo: for now we need to use the deprecated function, as we call it inside the mutation. For the future, we need to refactor it and ideally create a hook for picking/taking images
export const compressImage = async (
  imageUri: string,
  originalSize: number
): Promise<string> => {
  //  Start quality: never 1 (especially on web) as it causes canvas inflation (e.g. 10MB file is after first manipulation 80MB)
  let quality = Math.min(0.8, MAX_SIZE / originalSize);

  let compressed = await ImageManipulator.manipulateAsync(imageUri, [], {
    compress: quality,
    format: ImageManipulator.SaveFormat.JPEG
  });

  let size = await getFileSize(compressed.uri);

  // Reduce quality until under 10MB
  while (size > MAX_SIZE && quality > 0.1) {
    // scale down proportionally from current quality
    quality = Math.max(0.1, quality * (MAX_SIZE / size));

    compressed = await ImageManipulator.manipulateAsync(imageUri, [], {
      compress: quality,
      format: ImageManipulator.SaveFormat.JPEG
    });

    size = await getFileSize(compressed.uri);
  }

  if (size > MAX_SIZE) {
    throw new Error('Cannot compress image below 10MB');
  }

  return compressed.uri;
};

export const processImage = async (image: ImagePickerAsset) => {
  const mimeType = image.mimeType ?? 'unknown';
  const size = image.fileSize ?? 0;

  if (ACCEPTED_MIME_TYPES.has(mimeType) && size <= MAX_SIZE) {
    return image.uri;
  }

  // Need to compress/convert
  return compressImage(image.uri, size);
};
